import { loginService } from "../services";
import router from "../router";

const user = JSON.parse(localStorage.getItem("user"));
const state = user
    ? { status: { loggedIn: (user.mfa !== true) }, user }
    : { status: { loggedIn: false }, user: null };

const actions = {
    login({ dispatch, commit }, { username, password }) {
        commit("loginRequest", { username });

        loginService.login(username, password)
            .then(
                data => {
                    if (data.user.userid) {
                        commit("loginSuccess", data.user);
                        router.push({ name: data.user.mfa ? 'mfaCodeValidation' : data.user.redirectTo });
                    }
                    else {
                        commit("lockUser", data.user);
                        dispatch("alert/error", "login.lockedOut", { root: true });
                    }
                },
                error => {
                    commit("loginFailure", error.message);
                    dispatch("alert/error", error.message, { root: true });
                }
            );
    },
    logout({ commit }) {
        loginService.logout();
        commit("logout");
    },
    validateMFACode({ dispatch, commit }, { audit, mfacode, userid }) {
        loginService.validateMFACode(audit, mfacode, userid)
            .then(
                user => {
                    commit("loginMFASuccess", user);
                    router.push({ name: user.redirectTo });
                },
                error => {
                    commit("loginMFAFailure");
                    dispatch("alert/error", error.message, { root: true });
                }
            )
    },
    updateSearchPreference({ commit }, { searchPreference, reportCode }) {
        try {
            let searchPreferences = [];
            if (state.user.searchPreference) {
                searchPreferences = JSON.parse(state.user.searchPreference)

                if (searchPreferences) {
                    let userSearchPreference = searchPreferences.find(x => x.IndexDefinitionCode == reportCode);

                    if (userSearchPreference) {
                        userSearchPreference.SearchMethod = searchPreference.searchMethod;
                        userSearchPreference.SearchColumns = searchPreference.searchColumns;
                    } else {
                        searchPreferences.push({
                            IndexDefinitionCode: reportCode,
                            SearchMethod: searchPreference.searchMethod,
                            SearchColumns: searchPreference.searchColumns,
                        });
                    }
                }
                else {
                    searchPreferences = [{
                        IndexDefinitionCode: reportCode,
                        SearchMethod: searchPreference.searchMethod,
                        SearchColumns: searchPreference.searchColumns,
                    }];
                }
            }
            else {
                searchPreferences = [{
                    IndexDefinitionCode: reportCode,
                    SearchMethod: searchPreference.searchMethod,
                    SearchColumns: searchPreference.searchColumns,
                }];
            }
            commit("commitUpdateSearchPreference", JSON.stringify(searchPreferences));
        }
        catch (error) {
            console.log(`updateSearchPreference error: ${error}`);
        }
    }
};

const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: (user?.mfa !== true) };
        state.user = user;
    },
    lockUser(state, user) {
        state.status = {};
        state.user = user;
    },
    loginMFASuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    loginMFAFailure(state) {
        state.status = { loggedIn: false };
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    registerRequest(state) {
        state.status = { registering: true };
    },
    registerSuccess(state) {
        state.status = {};
    },
    registerFailure(state) {
        state.status = {};
    },
    commitUpdateSearchPreference(state, searchPreferences) {
        state.user.searchPreference = searchPreferences;
    }
};

export const account = {
    namespaced: true,
    state,
    actions,
    mutations,
};
